import { render, staticRenderFns } from "./LogVolumeChart.vue?vue&type=template&id=5ccb9e56&scoped=true"
import script from "./LogVolumeChart.vue?vue&type=script&lang=js"
export * from "./LogVolumeChart.vue?vue&type=script&lang=js"
import style0 from "./LogVolumeChart.vue?vue&type=style&index=0&id=5ccb9e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccb9e56",
  null
  
)

export default component.exports